import React, { useEffect, useState } from "react";
import "./style.css";

import GoogleMapReact from "google-map-react";
import MyMarker from "./MyMarker";
import Loader from "components/Loader";

// implementation of this function is needed for codesandbox example to work
// you can remove it otherwise
const distanceToMouse = (pt, mp) => {
  if (pt && mp) {
    // return distance between the marker and mouse pointer
    return Math.sqrt(
      (pt.x - mp.x) * (pt.x - mp.x) + (pt.y - mp.y) * (pt.y - mp.y)
    );
  }
};
export default function Map({ driverMap = [], dadhboardMapCoordinates }) {
  const [coordinates, setcoordinates] = useState([]);

  const getEveryCoordinate = () => {
    setcoordinates({
      latitude: dadhboardMapCoordinates[0]?.latitude,
      longitude: dadhboardMapCoordinates[0]?.longitude,
    });
  };

  useEffect(() => {
    getEveryCoordinate();
  }, [dadhboardMapCoordinates]);

  return (
    <>
      {dadhboardMapCoordinates?.length > 0 ? (
        <div className="Map">
          <GoogleMapReact
            bootstrapURLKeys={{
              // remove the key if you want to fork
              key: "AIzaSyDiKc4HxX5G7EfneIZBN_Hlk2_luoT_yvo",
              language: "en",
              region: "US",
            }}
            center={{
              lat: dadhboardMapCoordinates[0]?.latitude,
              lng: dadhboardMapCoordinates[0]?.longitude,
            }}
            defaultCenter={{ lat: 31.1471, lng: 75.3412 }}
            defaultZoom={8}
            distanceToMouse={distanceToMouse}
            yesIWantToUseGoogleMapApiInternals
          >
            {dadhboardMapCoordinates.map((item) => {
              //  const {user_id,latitude,longitude,name,username}=mapData;
              return (
                <MyMarker
                  key={item?.id}
                  lat={item?.latitude}
                  lng={item?.longitude}
                  text={item?.name}
                  tooltip={item?.name}
                />
              );
            })}
          </GoogleMapReact>
        </div>
      ) : (
        <div className="Map">
          <GoogleMapReact
            bootstrapURLKeys={{
              // remove the key if you want to fork
              key: "AIzaSyDiKc4HxX5G7EfneIZBN_Hlk2_luoT_yvo",
              language: "en",
              region: "US",
            }}
            defaultCenter={{ lat: 31.1471, lng: 75.3412 }}
            defaultZoom={8}
            distanceToMouse={distanceToMouse}
            yesIWantToUseGoogleMapApiInternals
          >
            {dadhboardMapCoordinates.map((item) => {
              //  const {user_id,latitude,longitude,name,username}=mapData;
              return (
                <MyMarker
                  key={item?.id}
                  lat={item?.latitude}
                  lng={item?.longitude}
                  text={item?.name}
                  tooltip={item?.name}
                />
              );
            })}
          </GoogleMapReact>
        </div>
      )}
    </>
  );
}
